import React, { useEffect, useMemo, useState} from "react";

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
// store
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';


// routing
import Routes from './routes/index';

// defaultTheme
import themes from './themes/index';

// project imports
import NavigationScroll from './component/NavigationScroll/Index';
import Snackbar from './component/Snackbar/Index';
import SessionExpire from './component/Modal/SessionExpire';
import { SNACKBAR_STATUS } from "./store/actions";
import { LOGIN_STATUS,LOGOUT } from "./store/actions";

// ==============================|| APP ||============================== //

const App = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;

    const [sessionOpen, setSessionOpen] = useState(false);

    const customization = useSelector((state) => state.aiwritemate);
    const { snackbarStatus,tokenExpire } = customization;
    
    const dispatch = useDispatch();
// const expirationTime=0;
    const handleCloseSnackbar = () => {
        dispatch({
            type: SNACKBAR_STATUS, snackbarStatus: {
                snackbarOpen: false,
                snackbarTitle: "",
                snackbarseverity: ""
            }
        });
    };
    const handleSessionExpire=async()=>{        
        dispatch({ type: LOGOUT });
        setSessionOpen(false)
               navigate("/")
       
    }
    useEffect(() => {
   
        let interval;
      
        if (tokenExpire !== "") {
          
          interval = setInterval(() => {
            const currentTime = Date.now();
            // Refresh the token a minute early to avoid latency issues
            const expirationTimeConvert = parseInt(tokenExpire) * 1000 - 90000;
            // console.log("expire token enter")
            if (currentTime >= expirationTimeConvert) {
                setSessionOpen(true);
              clearInterval(interval);
            }
          }, 1000);
        }
    
        return () => clearInterval(interval);
      }, [tokenExpire]);


    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                    <Snackbar
                        open={snackbarStatus?.snackbarOpen}
                        title={snackbarStatus?.snackbarTitle}
                        severity={snackbarStatus?.snackbarseverity}
                        close={handleCloseSnackbar}
                    />
                     <SessionExpire
                     open={sessionOpen}
        title="Session has been Expired!"
        description="Please re-login to continue"
        btnText="Re-Login"
        confirm={handleSessionExpire}
      />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
